import { useTranslation } from 'react-i18next'
import Typography from '@mui/material/Typography'
import { AIP_SOURCES } from '@jupi/shared'
import { useDataSources } from '../../api/plan'

// "AIP FI 01 OCT 2026 · AIP EE 2026-10-01 · checked 6.10.2026": which AIP
// edition each country's aerodrome data is from, and when they were last
// looked at. Renders nothing until an AIP has an edition to report.
export default function DataSourcesNote({ prefix = '' }: { prefix?: string }) {
  const { t, i18n } = useTranslation()
  const { data: sources = [] } = useDataSources()
  const loaded = sources.filter((s) => s.revision && s.source in AIP_SOURCES)
  if (loaded.length === 0) return null
  const when = (iso: string) =>
    new Intl.DateTimeFormat(i18n.language, { dateStyle: 'medium', timeStyle: 'short' }).format(new Date(iso))
  // The latest check of any country (ISO timestamps order as text).
  const checked = loaded.reduce<string | null>((latest, s) => (s.lastCheckedAt && (!latest || s.lastCheckedAt > latest) ? s.lastCheckedAt : latest), null)
  const parts = [
    ...loaded.map((s) =>
      t('plan.dataSources.aip', { country: AIP_SOURCES[s.source].country.toUpperCase(), revision: s.revision!.split('_')[0] }),
    ),
    checked ? t('plan.dataSources.checked', { when: when(checked) }) : null,
  ].filter(Boolean)
  return (
    <Typography variant="caption" color="text.secondary" component="span">
      {prefix}
      {parts.join(' · ')}
    </Typography>
  )
}
